export default "__VITE_ASSET__BOA93hxb__"